import { useEffect, useState } from 'react';
const useWindowLocationHref = () => {
  const [href, setHref] = useState(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHref(window.location.href);
    }
  }, []);
  return href;
};
export default useWindowLocationHref;
